import React from 'react';
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import DownloadApp from '../../sections/DownloadApp/DownloadApp';
import LearningHub from '../../sections/LearningHub/LearningHub';
import WhyChooseUs from '../../sections/WhyChooseUs/WhyChooseUs';
import { ExternalLink } from 'lucide-react';
import './DontHaveGSTIN.css';

export default function DontHaveGSTIN() {
  return (
    <div className="dont-gstin-page">
      <Navbar />

      <main className="dont-gstin-main">
        <section className="dont-gstin-hero">
          <div className="dont-gstin-hero-container dont-gstin-content">
            <div className="dont-gstin-hero-grid">
              <div className="dont-gstin-hero-copy">
                <h1 className="dont-gstin-hero-heading">
                  <span className="blue-text">No GSTIN?</span> Still eligible to sell on Haatza
                </h1>
                <p className="dont-gstin-hero-subtext">
                  Whether you're running a big brand or a small business, you can now sell to millions of customers within your state - no Regular GSTIN required!
                </p>
                <a href="/signin" style={{ textDecoration: 'none' }}>
                  <button className="dont-gstin-hero-cta-btn">Start Selling</button>
                </a>
              </div>

              <div className="dont-gstin-hero-visual">
                <img
                  src="https://static.wixstatic.com/media/73d0ef_98781a8e3e15405ba013fe9c9fcacf8d~mv2.png/v1/fill/w_671,h_561,fp_0.67_0.29,q_90,usm_0.66_1.00_0.01,enc_avif,quality_auto/gst.png"
                  alt="Seller sitting on beanbag with laptop"
                  className="dont-gstin-hero-man-img"
                />
              </div>
            </div>
          </div>
        </section>

        <section className="dont-gstin-opportunities">
          <div className="dont-gstin-opportunities-container dont-gstin-content">
            <div className="dont-gstin-opportunities-body">
              <h2 className="dont-gstin-opportunities-title">
                Exciting Opportunity for Sellers without GSTIN or with Composition GSTIN – Join Haatza!
              </h2>
              <p className="custom-welcome-text-left-only">
                Haatza welcomes all sellers – even those without a GSTIN or those registered under Composition GSTIN – to start selling within their own state and reach<br /><span className="custom-centered-customers-line">thousands of customers.</span>
              </p>
              <p className="dont-gstin-opportunities-text">
                If you're not registered under GST, you'll need an Enrolment ID or UIN to complete the registration process.
              </p>
              <p className="dont-gstin-opportunities-text highlight-box">
                👉 Don't have one yet? No worries – you can apply for your Enrolment ID or UIN{" "}
                <a href="https://www.gst.gov.in/" target="_blank" rel="noopener noreferrer" className="dont-gstin-enrolment-link">
                  here
                </a>
                {" "}and then proceed to register on Haatza easily!
              </p>
              <p className="dont-gstin-opportunities-footer-text">
                Let your business grow with Haatza – even without a full GST registration!
              </p>
            </div>
          </div>
        </section>

        <section className="dont-gstin-benefits">
          <div className="dont-gstin-benefits-container dont-gstin-content">
            <div className="dont-gstin-benefits-grid">
              <div className="dont-gstin-benefits-left">
                <WhyChooseUs />
              </div>
              <div className="dont-gstin-benefits-visual">
                <img
                  src="https://static.wixstatic.com/media/fe689e_fcd77a0553ae4ebea89762eeaadd511d~mv2.jpg/v1/fill/w_449,h_671,fp_0.34_0.27,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/3c90689307.jpg"
                  alt="Seller using Haatza"
                  className="dont-gstin-benefits-img"
                />
              </div>
            </div>
          </div>
        </section>

        <section className="dont-gstin-learning">
          <div className="dont-gstin-learning-container dont-gstin-content">
            <div className="dont-gstin-learning-left">
              <LearningHub />
            </div>
          </div>
        </section>

        <section className="dont-gstin-download">
          <div className="dont-gstin-download-container dont-gstin-content">
            <DownloadApp />
          </div>
        </section>

        <section
          className="support-center-fullwidth-section light-blue-bg section-anchor"
          id="support-center"
        >
          <div className="support-center-inner-container sell-online-mobile-support-inner">
            <div className="support-badge-brand sell-online-700-750-support-title sell-online-700-750-support-center">
              <span className="brand-h">Haatza</span>
              <span className="brand-divider-pipe"></span>
              <div className="brand-sub-stacked">
                <span className="brand-sub-top">Seller</span>
                <span className="brand-sub-bottom">
                  <span className="brand-support-bold">Support</span> Center
                </span>
              </div>
            </div>

            <div className="support-grid-2">
              <div className="support-copy">
                <h2 className="section-h2 support-2row-heading sell-online-mobile-support-heading-247 sell-online-750-1000-support-subheading sell-online-700-750-support-heading">
                  Haatza Supplier Support<br />Available 24/7
                </h2>
              </div>

              <div className="support-action-box support-action-box-independent sell-online-mobile-support-action-content">
                <p className="support-box-text sell-online-700-750-support-description">
                  Haatza supplier support is available to solve all your doubts and issues before and after you start your online selling business.
                </p>
                <div className="email-link-with-icon">
                  <img
                    src="https://static.wixstatic.com/media/fe689e_95aad345b1974df184b72c160c176a36~mv2.png/v1/fill/w_76,h_75,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/Screenshot%202025-01-25%20at%2011_edited.png"
                    alt="Support Mail Icon"
                    className="support-mail-img"
                  />
                  <p className="contact-email-link">
                    You can reach out to<br />
                    <a href="mailto:sales@haatza.com">sales@haatza.com</a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}